function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15
}, React.createElement("animate", {
  attributeName: "r",
  from: 15,
  to: 15,
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "fill-opacity",
  from: 1,
  to: 1,
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 60,
  cy: 15,
  r: 9,
  fillOpacity: 0.3
}, React.createElement("animate", {
  attributeName: "r",
  from: 9,
  to: 9,
  begin: "0s",
  dur: "0.8s",
  values: "9;15;9",
  calcMode: "linear",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "fill-opacity",
  from: 0.5,
  to: 0.5,
  begin: "0s",
  dur: "0.8s",
  values: ".5;1;.5",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 105,
  cy: 15,
  r: 15
}, React.createElement("animate", {
  attributeName: "r",
  from: 15,
  to: 15,
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "fill-opacity",
  from: 1,
  to: 1,
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

var SvgLoadingIndicator = function SvgLoadingIndicator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 120,
    height: 30,
    viewBox: "0 0 120 30",
    fill: "#fff",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoadingIndicator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading-indicator.a78fc4c8.svg";
export { ForwardRef as ReactComponent };